var map = {
	"./clicked.png": 5925,
	"./clicked0.png": 9633,
	"./clicked1.png": 8504,
	"./clicked2.png": 4259,
	"./clicked3.png": 9050,
	"./clicked4.png": 8306,
	"./clicked5.png": 9388,
	"./clickedTileHover0.png": 547,
	"./clickedTileHover1.png": 9322,
	"./clickedTileHover2.png": 9489,
	"./clickedTileHover3.png": 5272,
	"./clickedTileHover4.png": 6791,
	"./clickedTileHover5.png": 8478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7880;